import { decodeSkillsSession } from 'models/Candidate/SkillsSession';
import { ServerApi } from 'modules/api/server-api';

export const fetchCandidateSkillsSessions = (api: ServerApi) => async () => {
  const response = await api.get('/candidate/iwuskill-sessions');
  return response.data.data.map((item: any) => decodeSkillsSession(item));
};
